import styled from 'styled-components'

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	--btn-width: 90%;
	--btn-bg-color: var(--btn-color);
	--btn-bg-disabled: var(--btn-color-disabled);
	--btn-text-color: var(--text-color);
	--btn-text-disabled: var(--text-color-disabled);
	--btn-border-radius: var(--border-radius-sm);
	--btn-height: var(--it-hg-lg);
`

export const ButtonText = styled.span`
	letter-spacing: 0.46px;
	font-size: var(--fs-sm);
	font-weight: var(--fw-md);
`
